/**
 * DTemplate Page
 * Password-gated fullscreen slide deck viewer — the draft deck on
 * Distributional's template
 */

import React from 'react';
import { PitchDeck, DTEMPLATE } from '@components/press/pitch-deck';

export const DTemplatePage: React.FC = () => <PitchDeck edition={DTEMPLATE} />;
